/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * MegaMenu - Move heading above image in MegaMenu PushLinks
 *
 * This script reorders elements within each `.MegaMenu__PushLink` by
 * moving the `.MegaMenu__PushHeading` above the `.MegaMenu__PushImageWrapper`.
 *
 * Author: Sander Langendoen
 * Date: 2025-05-28
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.MegaMenu__PushLink').forEach(function (link) {
    const heading = link.querySelector('.MegaMenu__PushHeading');
    if (heading) {
      link.insertBefore(heading, link.firstChild);
    }
  });
});

/**
 * MegaMenu Enhancements
 *
 * This script extends the Shopify MegaMenu by injecting:
 * - Location details under the "Find us here" menu
 * - A newsletter subscription form under the "Newsletter" item in the "About" menu
 *
 * Author: Sander Langendoen
 * Date: 2025-05-28
 */
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll('.MegaMenu__Title');

  menuItems.forEach(item => {
    const title = item.textContent.trim();
    let extraHTML = '';

  //   // Inject locations
  //   if (title === 'Amsterdam Store') {
  //     extraHTML = `
  //       <p>Van Baerlestraat 46<br>
  //       1071 AZ Amsterdam<br>
  //       +31 (0)6 19 00 33 44<br>
  //       <a href="mailto:boutique.amsterdam@bibivandervelden.com">boutique.amsterdam@bibivandervelden.com</a><br><br>
  //       Tue - Sat, 10am - 6pm<br><br>
  //       </p>
  //     `;
  //   }

  //   if (title === 'Amsterdam Showroom') {
  //     extraHTML = `
  //       <p>Lauriergracht 6 A<br>
  //       1016 RL Amsterdam<br>
  //       +31 (0)6 21 92 87 35<br>
  //       <a href="mailto:info@bibivandervelden.com">info@bibivandervelden.com</a><br><br>
  //       Mon - Fri, 9am - 6pm<br><br>
  //       </p>
  //     `;
  //   }

  //   if (title === 'Rosewood Hotel') {
  //     extraHTML = `
  //       <p>House 020<br>
  //       Prinsengracht 432-436<br>
  //       1017 KE Amsterdam<br>
  //       <a href="mailto:info@bibivandervelden.com">info@bibivandervelden.com</a><br><br>
  //       Tue - Sat, 10am - 6pm<br><br>
  //       </p>
  //     `;
  //   }

  //   if (extraHTML) {
  //     const parent = item.closest('.MegaMenu__Item');
  //     const infoDiv = document.createElement('div');
  //     infoDiv.classList.add('MegaMenu__ExtraInfo');
  //     infoDiv.innerHTML = extraHTML;
  //     parent.appendChild(infoDiv);
  //   }


    if (title === 'Newsletter') {
      const parent = item.closest('.MegaMenu__Item');
      const wrapper = document.createElement('div');
      wrapper.classList.add('MegaMenu__NewsletterWrapper');
      wrapper.innerHTML = `
        <p class="MegaMenu__NewsletterIntro">
          Sign up to our newsletter and we’ll keep you posted on new jewellery pieces and special events.
        </p>
        <form id="MegaMenuNewsletterForm" class="MegaMenuNewsletterForm" novalidate>
          <div class="MegaMenuNewsletterForm__Wrapper">
            <input
              type="email"
              id="MegaMenuNewsletterEmail"
              class="MegaMenuNewsletterEmail"
              placeholder="Enter your email address"
              required
            >
            <button type="submit" class="MegaMenuNewsletterButton" disabled>
              <svg class="ArrowIcon" fill="none" height="16" viewBox="0 0 20 16" width="20" xmlns="http://www.w3.org/2000/svg">
                <g stroke="#b8b8b8" stroke-linecap="round" stroke-linejoin="round" stroke-width=".513514">
                  <path d="M0.567627 7.79818 L18.8374 7.81104"/>
                  <path d="M11.8777 0.621866 L19.0541 7.81106 L11.8777 15.0002"/>
                </g>
              </svg>
            </button>
          </div>
        </form>
      `;
      parent.appendChild(wrapper);

      const emailInput = wrapper.querySelector("#MegaMenuNewsletterEmail");
      const submitButton = wrapper.querySelector(".MegaMenuNewsletterButton");

      // Pijl tonen/verbergen
      emailInput.addEventListener("input", function () {
        const hasText = emailInput.value.trim().length > 0;

        if (hasText) {
          submitButton.disabled = false;
          submitButton.classList.add('visible');
        } else {
          submitButton.disabled = true;
          submitButton.classList.remove('visible');
        }
      });

      // Redirect bij submit of Enter
      const form = wrapper.querySelector("#MegaMenuNewsletterForm");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const email = emailInput.value.trim();
        if (email) {
          localStorage.setItem("newsletterEmail", email);
          window.location.href = "/pages/newsletter";
        }
      });

      /**
       * MegaMenu Newsletter Prefill on hover
       */
      const savedEmail = localStorage.getItem("newsletterEmail");

      if (!savedEmail) return;

      const tryPrefillNewsletter = () => {
        const emailInput = document.querySelector('input[name="contact[email]"]');

        if (emailInput && emailInput.value === '') {
          emailInput.value = savedEmail;
          emailInput.classList.remove('invalid', 'error');
          localStorage.removeItem("newsletterEmail");
        } else if (!emailInput && tryPrefillNewsletter.attempts < 20) {
          tryPrefillNewsletter.attempts++;
          setTimeout(tryPrefillNewsletter, 250);
        }
      };

      tryPrefillNewsletter.attempts = 0;
      tryPrefillNewsletter();
    }
  });

  /**
   * Event listener voor gecombineerde actie "search-and-close".
   *
   * Deze custom data-action bootst twee bestaande acties na:
   * 1. toggle-search   → opent/sluit de zoekfunctie
   * 2. close-drawer    → sluit het navigatie-drawer menu
   *
   * Waarom?
   * - Een element kan maar één `data-action` attribuut hebben.
   * - Door een nieuwe actie te maken, kunnen we toch meerdere bestaande
   *   functies tegelijk uitvoeren zonder dubbele attributen of code duplicatie.
   *
   * Werking:
   * - Luistert op documentniveau naar clicks (event delegation).
   * - Zoekt naar het aangeklikte element met `data-action="search-and-close"`.
   * - Simuleert vervolgens een click op de bestaande knoppen voor
   *   `toggle-search` en `close-drawer`, zodat de bestaande theme-logica
   *   gewoon wordt hergebruikt.
   *
   * Voordeel:
   * - Geen duplicate logic.
   * - Theme blijft future-proof: als de interne handlers wijzigen,
   *   klik je nog steeds gewoon op de originele triggers.
   */

  document.addEventListener('click', function (e) {
    const el = e.target.closest('[data-action="search-and-close"]');
    if (!el) return;

    // 1) Toggle search (roept dezelfde logica aan als data-action="toggle-search")
    const toggleSearchBtn = document.querySelector('[data-action="toggle-search"]');
    toggleSearchBtn?.click();

    // 2) Close drawer (roept dezelfde logica aan als data-action="close-drawer")
    const closeDrawerBtn = document.querySelector('[data-action="close-drawer"]');
    closeDrawerBtn?.click();
  });
});